import styled, {keyframes} from 'styled-components'
import {WhiteContainer, fontTitle, fontPrices} from '../../theme/theme'
import MainButton from '../MainButton'
import {DiscountContainer} from '../Discount/style';



type CartProps = {
    show: boolean;
};

type colorIcon = {
    color: string;
}

// -Animations

const slideShow = keyframes`
    from {
        transform: translate(1000px, 0);
        visibility: hidden;
        
    }
    to {
        transform: translate(0, 0);
        visibility: visible;
        
    }
`

const slideHide = keyframes`
    from {
        transform: translate(0, 0);
        visibility: visible;
        
    }
    to {
        transform: translate(1000px, 0);
        visibility: hidden;
        
    }
`

export const ShoppingCartContainer = styled(WhiteContainer)<CartProps>`
    box-sizing: border-box;
    position: fixed;
    z-index: 99999;
    display: flex;    
    height: auto;
    max-height: 100vh;
    max-width: 500px;
    right: 0;
    top: 0;
    margin: 0;
    flex-direction: column;
    padding: 1em 2em 1em 2em;
    animation: ${props => props.show ? slideShow : slideHide} .25s ${props => props.show ? 'ease' : 'ease-in-out'};
    @media (max-width: ${props => props.theme.breakpoints.md}){
        display: none;
    }
`

export const ShoppingCartTitle = styled.div`
    font-family: ${fontTitle};
    font-size: 30px;
    font-weight: 400;
    margin: .5em 0em;
    display: flex;
    align-items: center; 
    

`
export const ShoppingCartHeader = styled.div`
    display: flex;    
    align-items: center;
    flex-direction: column;
    &::after{
        content: "";
        display: flex;
        justify-content: center;
        width: 100%;
        height: 1px;
        background-color: #F6F6F6;
    }
`

export const CloseContainer = styled.div`
    margin-left: 10px;
`
export const ShoppingCartList = styled.div`
    display: flex;
    flex-direction: column;  
    margin: 1em 0em; 
    overflow-y: auto;
    align-items: center;
    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2.5px;
        background: #C4C4C4;
    }
    &::-webkit-scrollbar-track {
        border-radius: 2.5px;
        background: #F6F6F6;
    }
`
export const ProductListContainer = styled.div`
    display: flex;
    width: 100%
`
export const ProductImage = styled.div`
    position: relative;
    img{
        width: 100px;
        height: 100px;
        border-radius: 10px;
    }
`
type discountSize = {
    inCart: boolean;
}

export const DiscountInCart = styled(DiscountContainer)<discountSize>`
    border-width: ${props => props.inCart ? '1.5em' : 'inherit'};
    &::after{
        font-size: 12px;
        font-weight: bolder;
    }
    
`



export const LoadContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;

`;

export const ProductInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: .5em 1em;

    .cart-product-title{
        font-family: ${fontTitle};
        color: rgba(153, 153, 153, 1);
        font-size: 20px;
        font-weight: 400;

    }

    .cart-product-subTitle{
        font-family: ${fontPrices};
        color: rgba(153, 153, 153, 1);
        font-size: 15px;
        font-weight: 400;

    }

    .cart-product-discount{
        font-family: ${fontPrices};
        font-size: 18px;
        font-weight: 700;
    }

    .cart-product-normalPrice{
        font-family: ${fontPrices};
        font-size: 18px;
        font-weight: 700;
    }
`
export const DeleteProduct = styled.div<colorIcon>`
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
    align-items: center;
    width: 100%;
    svg{
        fill: #999999;
    }
    svg:hover{
        cursor: pointer;
        fill: ${props => props.color};
        stroke: ${props => props.color};
        stroke-width: .25px;
    }
`

export const EmptyCart = styled.div`
    display: flex;
    font-family: ${fontPrices};
    font-weight: 400;
    margin: 1em 0em;
    height: 15vh;
`
export const ButtonCart = styled(MainButton)`
    font-family: ${fontPrices};
    font-weight: 700;
`

